<template>
  <div class="content-wrap">
    <div class="user-box" v-if="user">
      <div class="user-flag" v-if="!user.isCheckMemFee && !user.isMemValid">未缴纳年费</div>
      <div class="user-flag-ing" v-if="user.isCheckMemFee">会费确认中</div>
      <div class="user-flag-yet" v-if="user.isMemValid == '1'">已缴纳会费</div>

      <div class="user-main">
        <div class="user-img">
          <img :src="user.portraitUrl" alt="" />
          <input v-if="!loading" type="file" accept="image/*" @change="onFileChange">
        </div>
        <div class="user-content">
          <div class="user-title-row">
            <span class="user-name">{{user.userName || '-'}}</span>
            <span class="user-type-tag" v-if="user.memTypeText">{{user.memTypeText}}</span>
          </div>
          <div class="user-meta-row">
            <span class="meta-item">
              <i class="meta-label">联系方式</i>
              <em>{{user.phone || '-'}}</em>
            </span>
            <span class="meta-divider"></span>
            <span class="meta-item meta-address">
              <i class="meta-label">通讯地址</i>
              <em :title="user.address || '-'">{{user.address || '-'}}</em>
            </span>
          </div>
          <div class="user-fee-row" v-if="memFeeRangeText">
            <span class="fee-chip">
              <i class="fee-label">会费期限</i>
              <em>{{memFeeRangeText}}</em>
            </span>
          </div>
          <div class="user-cert-row" v-if="showCertificateEntry">
            <button class="cert-entry-btn" type="button" @click="goCertificate">
              {{ certificateEntryText }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <FeeRemindBanner />

    <div class="content-main">
      <div class="content-header">
        <b>账户信息</b>
        <span>标有星号(*)的栏目为必填栏目，并请验证</span>
        <div class="content-header-op">
          <div class="edit-op" @click="onOpenResetPwdModal">修改密码</div>
        </div>
      </div>
      <div class="content-item">
        <div class="content-item-label">账号</div>
        <div class="content-item-value">{{user.account || '-'}}</div>
      </div>
      <div class="content-item">
        <div class="content-item-label">姓名*</div>
        <div class="content-item-value" v-if="!form.userName.edit">{{user.userName || '-'}}</div>  
        <div class="content-item-value edit"
             :class="form.userName.error ? 'error' : ''" 
            v-else>
          <input type="text" v-model="form.userName.value">
          <span @click="comfirmItem('userName')">确认</span>
          <span @click="cancelItem('userName')">取消</span>
          <div class="error-tip">{{form.userName.error}}</div>
        </div>  
        <div class="content-item-op">
          <div class="edit-op" v-if="!form.userName.edit" @click="editItem('userName')">修改</div>
        </div>      
      </div>
      <div class="content-item">
        <div class="content-item-label">手机*</div>
        <div class="content-item-value" v-if="!form.phone.edit">{{user.phone || '-'}}</div>  
        <div class="content-item-value edit"
             :class="form.phone.error ? 'error' : ''" 
              v-else>
          <input type="text" v-model="form.phone.value">
          <span @click="comfirmItem('phone')">确认</span>
          <span @click="cancelItem('phone')">取消</span>
          <div class="error-tip">{{form.phone.error}}</div>
        </div>  
        <div class="content-item-op">
          <div class="edit-op" v-if="!form.phone.edit" @click="editItem('phone')">修改</div>
        </div>      
      </div>
      <div class="content-item">
        <div class="content-item-label">邮箱*</div>
        <div class="content-item-value" v-if="!form.mailbox.edit">{{user.mailbox || '-'}}</div>  
        <div class="content-item-value edit"
            :class="form.mailbox.error ? 'error' : ''" 
             v-else>
          <input type="text" v-model="form.mailbox.value">
          <span @click="comfirmItem('mailbox')">确认</span>
          <span @click="cancelItem('mailbox')">取消</span>
          <div class="error-tip">{{form.mailbox.error}}</div>
        </div>  
        <div class="content-item-op">
          <div class="edit-op" v-if="!form.mailbox.edit" @click="editItem('mailbox')">修改</div>
        </div>      
      </div>
      <div class="content-item">
        <div class="content-item-label">通讯地址*</div>
        <div class="content-item-value" v-if="!form.address.edit">{{user.address || '-'}}</div>  
        <div class="content-item-value edit"  
            :class="form.address.error ? 'error' : ''"
            v-else>
          <input type="text" v-model="form.address.value">
          <span @click="comfirmItem('address')">确认</span>
          <span @click="cancelItem('address')">取消</span>
          <div class="error-tip">{{form.address.error}}</div>
        </div>  
        <div class="content-item-op">
          <div class="edit-op" v-if="!form.address.edit" @click="editItem('address')">修改</div>
        </div>      
      </div>
      <div class="content-header">
        <b>个人资料</b>
        <div class="content-header-op">
          <div class="edit-op" v-if="!editBaseFlag" @click="editBase">修改</div>
        </div>
      </div>
      <div class="content-item">
        <div class="content-item-label">身份证</div>
        <div class="content-item-value" v-if="!form.idCardNo.edit">{{user.idCardNo || '-'}}</div>
        <div class="content-item-value edit"
            :class="form.idCardNo.error ? 'error' : ''"
             v-else>
          <input type="text" v-model="form.idCardNo.value" @blur="validate(form.idCardNo)">
          <div class="error-tip">{{form.idCardNo.error}}</div>
        </div>  
      </div>
      <div class="content-item">
        <div class="content-item-label">学历</div>
        <div class="content-item-value" v-if="!form.highestEducationDicKey.edit">{{selectText('highestEducationDicKey') || '-'}}</div>
        <div class="content-item-value edit" v-else>
          <select :value="form.highestEducationDicKey.value" @change="e => selectChange(e, 'highestEducationDicKey')">
            <option v-for="(item, index) in form.highestEducationDicKey.options" :key="index" :value="item.value">{{item.name}}</option>
          </select>
        </div>  
      </div>
      <div class="content-item">
        <div class="content-item-label">政治面貌</div>
        <div class="content-item-value" v-if="!form.highestEducationDicKey.edit">{{selectText('politicalStatusDicKey') || '-'}}</div>
        <div class="content-item-value edit" v-else>
          <select :value="form.politicalStatusDicKey.value" @change="e => selectChange(e, 'politicalStatusDicKey')">
            <option v-for="(item, index) in form.politicalStatusDicKey.options" :key="index" :value="item.value">{{item.name}}</option>
          </select>
        </div>  
      </div>
      <div class="content-item">
        <div class="content-item-label">出生日期</div>
        <div class="content-item-value" v-if="!form.birthDate.edit">{{dateText(user.birthDate) || '-'}}</div>
        <div class="content-item-value edit" v-else>
          <datetime format="YYYY-MM-DD" v-model="form.birthDate.value"></datetime>
        </div>
      </div>
      <div class="content-footer">
        <span v-if="editBaseFlag" @click="comfirmBase">确认</span>
        <span v-if="editBaseFlag" @click="cancelBase">取消</span>
      </div>
    </div>
    <Modal :visible="resetPwdVisible">
      <ResetPasswordModal
        @confirm="onResetPwdConfirm"
        @cancel="onResetPwdModalClose"
      />
    </Modal>
  </div>
</template>

<script>
import moment from 'moment';
import datetime from '@/components/DatetimePicker';
import Modal from '@/components/Modal';
import ResetPasswordModal from './components/ResetPasswordModal';
import FeeRemindBanner from './components/FeeRemindBanner';
import { resetUserInfo, resetUserPwd } from './service/api';
import upload from '@/service/upload';
import { mapState, mapActions } from 'vuex';
import router from '@/router';
const baseFormKeys = ['idCardNo', 'highestEducationDicKey', 'politicalStatusDicKey', 'birthDate'];
const phoneReg = /^(13|15|17|18|14)[0-9]{9}$/;
const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/;
export default {
  data() {
    return {
      loading: false,
      editBaseFlag: false,
      resetPwdVisible: false,
      form: {
        userName: {
          value: '',
          edit: false,
          error: false,
          validate: v => {
            if (!v) {
              this.form.userName.error = '请输入姓名';
              return false;
            }
            this.form.userName.error = '';
            return true;
          }
        },
        phone: {
          value: '',
          edit: false,
          error: false,
          validate: v => {
            if (!v) {
              this.form.phone.error = '请输入手机号';
              return false;
            }
            if (!phoneReg.test(v)) {
              this.form.phone.error = '手机号不合法';
              return false;
            }
            return true;
          }
        },
        mailbox: {
          value: '',
          edit: false,
          error: false,
          validate: v => {
            if (!v) {
              this.form.mailbox.error = '请输入邮箱';
              return false;
            }
            if (!mailReg.test(v)) {
              this.form.mailbox.error = '邮箱地址不合法';
              return false;
            }
            return true;
          }
        },
        address: {
          value: '',
          edit: false,
          error: false,
          validate: v => {
            if (!v) {
              this.form.address.error = '请输入地址';
              return false;
            }
            return true;
          }
        },
        idCardNo: {
          value: '',
          edit: false,
          error: false,
          validate: v => {
            const reg = /(^\d{15}$)|(^\d{17}([0-9]|X)$)/;
            if (!v) {
              this.form.idCardNo.error = '请输入身份证号';
              return false;
            }
            if (!reg.test(v)) {
              this.form.idCardNo.error = '身份证号不合法';
              return false;
            }
            return true;
          }
        },
        highestEducationDicKey: {
          value: '',
          edit: false,
          options: [{
            value: 6001,
            name: '初中'
          },
          {
            value: 6002,
            name: '高中'
          },
          {
            value: 6003,
            name: '本科'
          },
          {
            value: 6004,
            name: '硕士'
          },
          {
            value: 6005,
            name: '博士'
          }]
        },
        politicalStatusDicKey: {
          value: '',
          edit: false,
          options: [
            {
              value: 1401,
              name: '中共党员'
            },
            {
              value: 1402,
              name: '中共预备党员'
            },
            {
              value: 1403,
              name: '共青团员'
            },
            {
              value: 1404,
              name: '民革党员'
            },
            {
              value: 1405,
              name: '民盟盟员'
            },
            {
              value: 1406,
              name: '民建会员'
            },
            {
              value: 1407,
              name: '民进会员'
            },
            {
              value: 1408,
              name: '农工党党员'
            },
            {
              value: 1409,
              name: '致公党党员'
            },
            {
              value: 1410,
              name: '九三学社社员'
            },
            {
              value: 1411,
              name: '台盟盟员'
            },
            {
              value: 1412,
              name: '群众'
            }
          ]
        },
        birthDate: {
          value: '',
          inputType: 'datePicker',
          edit: false
        }
      },
    }
  },
  computed: {
    ...mapState(['user']),
    memFeeRangeText() {
      if (!this.user || this.user.isMemValid != '1') {
        return '';
      }
      const start = this.user.membershipFeeStartDate;
      const end = this.user.membershipFeeValidDate;
      if (!start && !end) {
        return '';
      }
      const fmt = (t) => (t ? moment(t * 1000).format('YYYY-MM-DD') : '-');
      return `${fmt(start)} 至 ${fmt(end)}`;
    },
    showCertificateEntry() {
      return this.user && (this.user.memType === 'personal' || this.user.memType === 'org');
    },
    certificateEntryText() {
      if (this.user && this.user.memType === 'org') {
        const hasCert = this.user.memOrgVo && this.user.memOrgVo.certificateUrl;
        return hasCert ? '查看 / 下载团体证书' : '团体证书';
      }
      const hasCert = this.user && this.user.memPersonalVo && this.user.memPersonalVo.certificateUrl;
      return hasCert ? '查看 / 下载个人证书' : '个人证书';
    },
  },
  components: {
    datetime,
    Modal,
    ResetPasswordModal,
    FeeRemindBanner,
  },
  methods: {
    ...mapActions(['getUserInfo']),
    goCertificate() {
      if (this.user && this.user.memType === 'org') {
        router.push('/system/user?c=OrgCertificate');
        return;
      }
      router.push('/system/user?c=PersonalCertificate');
    },
    onFileChange($event) {
			const file = $event.target.files[0];
			if (this.loading) return false;
			this.loading = true;
			upload(file).then(url => {
        const params = {
          id: this.user.id,
          portraitUrl: url
        }
				resetUserInfo(params).then(() => {
          this.getUserInfo();
          this.$message({
            type: 'success',
            content: '操作成功'
          });
        }).catch(err => {
          this.$message({
            type: 'error',
            content: err
          });
        });
			}).finally(() => {
				this.loading = false;
			})
		},
    selectText(fieldName) {
      const value = this.user[fieldName];
      const field = this.form[fieldName];
      if (field && value) {
        const item = field.options.find(opt => opt.value == value);
        if (item) return item.name;
      }
      return '';
    },
    dateText(timeStr) {
      if (timeStr) {
        return moment(timeStr * 1000).format('YYYY-MM-DD');
      }
      return ''
    },
    editBase() {
      this.editBaseFlag = true;
      baseFormKeys.map(fieldName => this.editItem(fieldName));
    },
    selectChange(e, fieldName) {
      const value = e.target.value;
      const field = this.form[fieldName];
      field.value = value;
    },
    editItem(fieldName) {
      const field = this.form[fieldName];
      if (field.inputType === 'datePicker') {
        if (this.user[fieldName]) {
          field.value = moment(this.user[fieldName] * 1000).format('YYYY-MM-DD');
        } else {
          field.value = moment().format('YYYY-MM-DD');
        }
      } else {
        field.value = this.user[fieldName];
      }
      field.edit = true;
    },
    validate(field) {
      if (field.validate && !field.validate(field.value)) {
        return false;
      };
    },
    comfirmItem(fieldName) {
      const field = this.form[fieldName];
      if (field.validate && !field.validate(field.value)) {
        return false;
      };
      field.error = false;
      const params = {
        id: this.user.id,
        [fieldName]: field.value
      }
      resetUserInfo(params).then(() => {
        this.cancelItem(fieldName);
        this.getUserInfo();
        this.$message({
          type: 'success',
          content: '操作成功'
        });
      }).catch(err => {
        this.$message({
          type: 'error',
          content: err
        });
      });
    },
    cancelItem(fieldName) {
      const field = this.form[fieldName];
      field.error = false;
      field.edit = false;
    },
    comfirmBase() {
      const params = {
        id: this.user.id
      }
      for(let key of baseFormKeys) {
        const field = this.form[key];
        if (field instanceof Object === false) break;
        if (field.validate && !field.validate(field.value)) {
          return false;
        }
        field.error = false;
        if (field.inputType === 'datePicker' && field.value) {
          params[key] = moment(field.value).valueOf()/1000;
        } else if (field.value) {
          params[key] = field.value;
        }
      }
      resetUserInfo(params).then(() => {
        this.cancelBase();
        this.getUserInfo();
        this.$message({
          type: 'success',
          content: '操作成功'
        });
      }).catch(err => {
        this.$message({
          type: 'error',
          content: err
        });
      });
    },
    cancelBase() {
      baseFormKeys.map(fieldName => this.cancelItem(fieldName));
      this.editBaseFlag = false;
    },
    onOpenResetPwdModal() {
      this.resetPwdVisible = true;
    },
    onResetPwdConfirm(formData) {
      const params = {
        id:this.user.id,
        originalPassword: formData.originalPassword.value,
        newPassword: formData.newPassword.value,
        confirmPassword: formData.confirmPassword.value,
      }
      resetUserPwd(params).then(() => {
        this.onResetPwdModalClose();
        this.$message({
            type: 'success',
            content: '修改密码成功'
          });
        }).catch(err => {
          this.$message({
            type: 'error',
            content: err
          });
        });
    },
    onResetPwdModalClose() {
      this.resetPwdVisible = false;
    }
  }
}
</script>

<style lang="less" scoped>
.edit-op {
  cursor: pointer;
  padding-left: 24px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #06AE63;
  background: url(../../assets/images/icon-edit.png) no-repeat 0
    center;
  background-size: 16px 16px;
}
.datetime-picker input {
  border: 1px solid #ddd;
}
.user-box {
  width: 100%;
  min-height: 148px;
  padding: 28px 40px;
  background: url(../../assets/images/member-user-info-bg.png) no-repeat center
    center;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  position: relative;
  margin-bottom: 12px;
  box-sizing: border-box;

  .user-flag,
  .user-flag-ing,
  .user-flag-yet {
    width: 90px;
    height: 32px;
    border-radius: 0 0 0 12px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 32px;
    text-align: center;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 1;
  }

  .user-flag {
    background: linear-gradient(135deg, #ff8a4c 0%, #ff6b35 100%);
  }

  .user-flag-ing {
    background: #e3d63a;
  }

  .user-flag-yet {
    background: #30db7c;
  }

  .user-main {
    display: flex;
    align-items: center;
    width: 100%;
    padding-right: 100px;
    box-sizing: border-box;
  }

  .user-img {
    flex: 0 0 72px;
    width: 72px;
    height: 72px;
    margin-right: 24px;
    cursor: pointer;
    position: relative;

    > img {
      display: block;
      width: 100%;
      height: 100%;
      border-radius: 50%;
      object-fit: cover;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    }

    &:hover {
      &::after {
        position: absolute;
        content: '';
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        border-radius: 50%;
        background: rgba(0, 0, 0, .3) url(../../assets/images/icon-edit.png) no-repeat center center;
        background-size: 20px 20px;
        pointer-events: none;
      }
    }

    > input {
      position: absolute;
      cursor: pointer;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      z-index: 1;
    }
  }

  .user-content {
    flex: 1;
    min-width: 0;
  }

  .user-title-row {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
  }

  .user-name {
    font-size: 22px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #131415;
    line-height: 1.2;
    margin-right: 12px;
    max-width: 60%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .user-type-tag {
    flex-shrink: 0;
    height: 24px;
    padding: 0 10px;
    border-radius: 12px;
    background: rgba(6, 174, 99, 0.12);
    color: #06ae63;
    font-size: 12px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    line-height: 24px;
  }

  .user-meta-row {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    min-width: 0;
    margin-bottom: 10px;
  }

  .meta-item {
    display: inline-flex;
    align-items: baseline;
    min-width: 0;
    max-width: 100%;

    .meta-label {
      flex-shrink: 0;
      font-style: normal;
      font-size: 13px;
      color: #9a9a9a;
      margin-right: 8px;
      font-family: PingFangSC-Regular, PingFang SC;
    }

    em {
      font-style: normal;
      font-size: 14px;
      color: #333;
      font-family: PingFangSC-Regular, PingFang SC;
      white-space: nowrap;
    }

    &.meta-address {
      flex: 1;
      min-width: 0;

      em {
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }

  .meta-divider {
    flex-shrink: 0;
    width: 1px;
    height: 12px;
    background: #d8d8d8;
    margin: 0 16px;
  }

  .user-fee-row {
    display: flex;
    align-items: center;
  }

  .user-cert-row {
    margin-top: 12px;
  }

  .cert-entry-btn {
    height: 32px;
    padding: 0 16px;
    border: 1px solid #06ae63;
    border-radius: 16px;
    background: #fff;
    color: #06ae63;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;

    &:hover {
      background: rgba(6, 174, 99, 0.08);
    }
  }

  .fee-chip {
    display: inline-flex;
    align-items: center;
    max-width: 100%;
    height: 28px;
    padding: 0 12px;
    border-radius: 14px;
    background: linear-gradient(90deg, rgba(48, 219, 124, 0.14), rgba(6, 174, 99, 0.08));
    border: 1px solid rgba(6, 174, 99, 0.22);

    .fee-label {
      flex-shrink: 0;
      font-style: normal;
      font-size: 12px;
      color: #06ae63;
      margin-right: 8px;
      font-family: PingFangSC-Medium, PingFang SC;
    }

    em {
      font-style: normal;
      font-size: 13px;
      color: #1f7a4d;
      font-family: PingFangSC-Medium, PingFang SC;
      letter-spacing: 0.2px;
      white-space: nowrap;
    }
  }
}
.content-main {
  padding: 40px;
  background: #FFFFFF;

  .content-header {
    padding-bottom: 20px;
    border-bottom: 1px solid #EEEEEE;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #787878;
    line-height: 20px;
    margin-bottom: 30px;
    display: flex;
    align-items: center;
    
    b {
      font-size: 20px;
      font-weight: 500;
      color: #131415;
      margin-right: 10px;
    }

    &-op {
      margin-left: auto;
    }
  }

  .content-item {
    margin-bottom: 32px;
    height: 32px;
    display: flex;
    align-items: center;

    &-label {
      width: 80px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #787878;
      margin-right: 40px;;
    }

    &-value {

      > div {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #131415;
      }

      .datetime-picker {
        .datetime-picker-icon {
          top: 6px;
        }
      }

      &.edit {
        position: relative;

        .error-tip {
          position: absolute;
          left: 0;
          top: 100%;
          font-size: 12px;
          color: #FF3B2F;
          line-height: 20px;
          display: none;
        }

        &.error {

          > input {
            border: 1px solid #FF3B2F;
          }

          .error-tip {
            display: block;
          }
        }

        > input {
          background: #F5F5F5;
          margin-right: 20px;
          width: 250px;
          height: 32px;
          padding: 0 16px;
        }

        > span {
          margin-right: 5px;
          cursor: pointer;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #06AE63;
        }

        > select {
          width: 250px;
          height: 32px;
          background: #FFFFFF;
          border-radius: 2px;
          border: 1px solid #E6E7EB;
          outline: none;
          text-align: center;

          option {
            width: 41px;
            height: 22px;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #1B2841;
            line-height: 22px;
          }
        }
      }
    }

    &-op {
      margin-left: auto;
    }
  }

  .content-footer {
    span {
      margin-right: 5px;
      cursor: pointer;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #06AE63;
    }
  }
}
</style>